import { Banner, Button, Modal } from '@scale/scaleui';
import { useChatThemeStore } from 'react-scale/components/scalers/tasks/ThreadedInteraction/hooks/useChatThemeStore';

interface StepSubmissionConfirmationModalProps {
  open: boolean;
  title: string;
  description: string;
  onConfirm: (isConfirmed: boolean | null) => void;
}

export const StepSubmissionConfirmationModal = ({
  open,
  title,
  description,
  onConfirm,
}: StepSubmissionConfirmationModalProps) => {
  const theme = useChatThemeStore(state => state.theme);
  return (
    <Modal
      open={open}
      onClose={() => onConfirm(false)}
      title={title}
      theme={theme}
      actions={
        <div className="flex items-center gap-2 justify-end">
          <div>
            <Button
              className="scale-theme flex gap-1 items-center ml-1"
              onClick={() => onConfirm(false)}
              size="lg"
              variant="neutral"
            >
              Cancel
            </Button>
          </div>
          <div>
            <Button
              className="scale-theme flex gap-1 items-center ml-1"
              onClick={() => onConfirm(true)}
              size="lg"
              variant="primary"
            >
              Confirm
            </Button>
          </div>
        </div>
      }
    >
      <Banner
        background="white"
        backgroundVariant="white"
        buttonVariant="neutral"
        title={description}
        variant="warning"
      />
    </Modal>
  );
};
